'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("itFooterAccumulator", function (valeurUtils) {
  var defaultReducer = function defaultReducer(sum, current) {
    return sum + current;
  };
  var reducers = {
    number: function number(data, attribute) {
      return _.reduce(data, function (sum, current) {
        var value = _.get(current, attribute);
        if (value) {
          return sum + value;
        }
        return sum;
      }, 0);
    },
    montant: function montant(data, attribute) {
      var total = null;
      for (var i = 0; i < data.length; i++) {
        var current = _.get(data[i], attribute);
        if (total == null) {
          total = current;
        } else {
          var sum = valeurUtils.addMontant(total, current);
          if (sum == null) {
            return null;
          }
          total = sum;
        }
      }
      return total;
    },
    taux: function taux(data, attribute) {
      var total = null;
      for (var i = 0; i < data.length; i++) {
        var current = _.get(data[i], attribute);
        if (total == null) {
          total = current;
        } else {
          total = valeurUtils.addValeur(total, current);
        }
      }
      return total;
    }
  };
  return {
    getEligibleTypes: function getEligibleTypes() {
      return Object.keys(reducers);
    },
    accumulate: function accumulate(dataSource, column) {
      var reducer;
      if (column.footerReducer) {
        if (typeof column.footerReducer === 'string') {
          reducer = reducers[column.footerReducer] || defaultReducer;
        } else {
          reducer = column.footerReducer;
        }
      } else {
        reducer = reducers[column.dataType] || defaultReducer;
      }
      try {
        return reducer(dataSource, column.attribute);
      } catch (e) {
        console.log("error accumulating data for column ".concat(column, ": ").concat(e));
        return null;
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/common/itFooterAccumulator.js
// module id = 2794
// module chunks = 13